import React from "react";
import _ from 'i18n';
import { Col, Row } from "antd";
import { Input } from "antd/lib/index";
import {
  setBudgetRegistrantsCount,
  setPricePerUnit,
  updateRegistrantsCountPerPrice,
  updateRegistrantsCountPerTargetBudget
} from "../../../../actions/actions/eventStats";
import { connect } from "react-redux";
import { formatAmount } from "../../../../services/utils";


const AnnualTargetManagementRow = ({
  legend,
  budgetManagement,
  setBudgetRegistrantsCount,
  setPricePerUnit,
  updateRegistrantsCountPerTargetBudget,
  updateRegistrantsCountPerPrice
}) => {

  const getValueFromStore = () => {
    const { globalBudget, budgetPerMonth, appType } = budgetManagement;

    if (legend === _('REGISTRANTS_TOTAL_NUMBER')) {
      return globalBudget.registrantsCount;
    } else if (legend === _('PRICE_PER_UNIT')) {
      return globalBudget.pricePerUnit;
    } else if (legend === _('TOTAL_BUDGET') && budgetManagement.appType !== 'monthly_premium') {
      return globalBudget.totalHTVA;
    } else if (legend === _('TOTAL_BUDGET') && budgetManagement.appType === 'monthly_premium') {
      if (globalBudget.registrantsCount !== 0 && globalBudget.pricePerUnit !== 0) {
        const cumulativeTotalHTVA = budgetPerMonth.map((month, index) => {
          let sum = 0;
          for (let i = 0; i <= index; i++) {
            sum += budgetPerMonth[i].totalHTVA;
          }
          return sum;
        });
        const totalSum = cumulativeTotalHTVA.reduce((total, value) => total + value, 0);
        return totalSum;
      } else {
        return globalBudget.totalHTVA;
      }
    } else {
      return '';
    }
  };

  const handleInputChange = (value) => {
    if (isNaN(value)) return;
    if (legend === _('REGISTRANTS_TOTAL_NUMBER')) {
      updateRegistrantsCountPerTargetBudget(value, budgetManagement.appType);
      setBudgetRegistrantsCount(value);
    } else if (legend === _('PRICE_PER_UNIT')) {
      updateRegistrantsCountPerPrice(value);
      setPricePerUnit(value);
    }
  };

  let value = getValueFromStore();
  const suffix = legend === _('REGISTRANTS_TOTAL_NUMBER') ? null : '€';

  return (
    <Row className={'budget-management-legend-row py-1'}>
      <Col span={10}>
        <div className={'budget-management-legend-label'}>
          {(legend === _('REGISTRANTS_TOTAL_NUMBER') && budgetManagement.appType === 'monthly_premium')
            ? _('NEW_REGISTRANTS_TOTAL_NUMBER')
            : legend}:
          {/*{(budgetManagement.isUpdatingAnnualTarget || budgetManagement.followUp.length > 0) &&*/}
          <div style={{ color: '#6d7f92' }}>
            {((legend === _('REGISTRANTS_TOTAL_NUMBER') || legend === _('NEW_REGISTRANTS_TOTAL_NUMBER'))) &&
              <span>({budgetManagement.lastGlobalBudget.registrantsCount})</span>}
            {legend === _('PRICE_PER_UNIT') &&
              <span>({formatAmount(budgetManagement.lastGlobalBudget.pricePerUnit)})</span>}
            {legend === _('TOTAL_BUDGET') &&
              <span>({formatAmount(budgetManagement.lastGlobalBudget.totalHTVA)})</span>}
          </div>

        </div>
      </Col>
      <Col
        span={8}>{(budgetManagement.followUp.length > 0 || budgetManagement.appType === 'all') ? (
          <div className={'budget-management-legend-input'}>
            <label>
              {legend === _('PRICE_PER_UNIT') || legend === _('TOTAL_BUDGET') ? formatAmount(value, false) : value}
            </label>
          </div>
        ) : legend === _('TOTAL_BUDGET') ? (
          <div className={'budget-management-legend-input'}>
            <label>{formatAmount(value, false)}</label>
          </div>
        ) : (
          <div className={'budget-management-legend-input'}>
            <Input
              suffix={suffix}
              value={value}
              onChange={(event) => handleInputChange(event.target.value)}
            />
          </div>
        )}
      </Col>
      <Col className={'pl-2'} span={6}>
        {legend === _('REGISTRANTS_TOTAL_NUMBER') &&
          <div className={'budget-comparaison'}>
            {budgetManagement.globalBudget.registrantsCountPercentage >= 0 ? (
              <div className={'budget-comparaison-icon'}>
                <img src="/img/icons/manage-BM/BM_plus.svg"
                  className={'mr-1'} />
                <span
                  className={'legend-comparaison-plus mr-1'}>{budgetManagement.globalBudget.registrantsCountPercentage}% </span>
              </div>
            ) : (
              <div>
                <img src="/img/icons/manage-BM/BM_moins.svg"
                  className={'mr-1'} />
                <span
                  className={'legend-comparaison-minus mr-1'}>{Math.abs(budgetManagement.globalBudget.registrantsCountPercentage)} % </span>
              </div>
            )
            }
          </div>
        }
        {legend === _('PRICE_PER_UNIT') &&
          <div className={'budget-comparaison'}>
            {budgetManagement.globalBudget.percentagePricePerUnit >= 0 ? (
              <div className={'budget-comparaison-icon'}>
                <img src="/img/icons/manage-BM/BM_plus.svg"
                  className={'mr-1'} />
                <span
                  className={'legend-comparaison-plus mr-1'}> {budgetManagement.globalBudget.percentagePricePerUnit}%  </span>
              </div>
            ) : (
              <div>
                <img src="/img/icons/manage-BM/BM_moins.svg"
                  className={'mr-1'} />
                <span
                  className={'legend-comparaison-minus mr-1'}>{Math.abs(budgetManagement.globalBudget.percentagePricePerUnit)}%</span>
              </div>
            )
            }
          </div>
        }
        {legend === _('TOTAL_BUDGET') &&
          <div className={'budget-comparaison'}>
            {budgetManagement.globalBudget.percentage >= 0 ? (
              <div className={'budget-comparaison-icon'}>
                <img src="/img/icons/manage-BM/BM_plus.svg" className={'mr-1'} />
                <span
                  className={'legend-comparaison-plus mr-1'}> {budgetManagement.globalBudget.percentage}% </span>
              </div>
            ) : (
              <div>
                <img src="/img/icons/manage-BM/BM_moins.svg"
                  className={'mr-1'} />
                <span
                  className={'legend-comparaison-minus mr-1'}>{Math.abs(budgetManagement.globalBudget.percentage)}% </span>
              </div>
            )
            }
          </div>
        }
      </Col>
    </Row>
  );
};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {
  setBudgetRegistrantsCount,
  setPricePerUnit,
  updateRegistrantsCountPerTargetBudget,
  updateRegistrantsCountPerPrice,

};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualTargetManagementRow);







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/AnnualTargetManagementRow.js